module.exports = __webpack_public_path__ + "6124a71e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_ser_14ftlorry.png
// module id = 1795
// module chunks = 0